export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13878.d9625bc9.jpg";